import { render, staticRenderFns } from "./passData.vue?vue&type=template&id=50d91038&scoped=true&"
import script from "./passData.vue?vue&type=script&lang=js&"
export * from "./passData.vue?vue&type=script&lang=js&"
import style0 from "./passData.vue?vue&type=style&index=0&id=50d91038&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d91038",
  null
  
)

export default component.exports